import { render, staticRenderFns } from "./FinalGrades.vue?vue&type=template&id=24202886&"
import script from "./FinalGrades.vue?vue&type=script&lang=js&"
export * from "./FinalGrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports